export default __webpack_public_path__ + "static/media/48k.2647f6a1.md";